import { render, staticRenderFns } from "./globe-alt.vue?vue&type=template&id=457fbde4&"
import script from "./globe-alt.vue?vue&type=script&lang=js&"
export * from "./globe-alt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports